import Vue from 'vue'

// Create a global event bus for cross-component communication
export const EventBus = new Vue()

// Event names
export const EVENTS = {
  SHIFT_CLOCK_IN: 'shift:clock-in',
  SHIFT_CLOCK_OUT: 'shift:clock-out',
  SHIFT_UPDATE: 'shift:update'
}
